import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { ModelWithCustomFieldIdentifier } from 'modules/custom_resources/store/collections/customFields/byGroup'
import Form from 'modules/surveys/store/models/Form'

export interface IQuestionsTemplate {
  id: number
  title: string
  type: 'survey' | 'review' | 'enps'
  default: boolean
  access_id: number
  company_id: number
  template_scope: 'core' | 'score'
  questions_count: number
}

class QuestionsTemplate
  extends Model<IQuestionsTemplate>
  implements ModelWithCustomFieldIdentifier
{
  static urlRoot() {
    return '/surveys/questions_templates'
  }

  constructor(attr: IQuestionsTemplate) {
    super(attr)
    makeObservable(this, {
      isSurvey: computed,
      isDefault: computed,
      isCore: computed,
      isScore: computed,
    })
  }

  customFieldsIdentifier(): string {
    return 'surveys-questions_template'
  }

  get isSurvey(): boolean {
    return this.attributes.type === Form.Types.survey
  }

  get isDefault(): boolean {
    return this.attributes.default
  }

  get isCore(): boolean {
    return this.attributes.template_scope === 'core'
  }

  get isScore(): boolean {
    return this.attributes.template_scope === 'score'
  }
}

export default QuestionsTemplate
